// https://app.growthbook.io/features/pen-7395_v2
export const EXPERIMENT_FLAG = 'pen-7395_v2'

const EXCLUDED_SLUGS = ['redefining-grief']

export const isExcludedSlug = (slug: string | undefined) =>
  !!slug && EXCLUDED_SLUGS.includes(slug)
